/**
 * Theme boundary (prompt.md §40, §44).
 *
 * WHY this exists as a component rather than a CSS file: the token stylesheet has
 * to be *derived* from `@dayvise/design-tokens` so the web app, the Tauri shell
 * and the Android Compose theme cannot drift. `DayviseTheme` renders the
 * generated block (hoisted by React 19 from wherever it is used), applies the
 * colour scheme, and paints the canvas — three jobs every application entry
 * point would otherwise repeat.
 */

import type { ReactNode } from "react";

import { dayviseStylesheet } from "./stylesheet.ts";

export type ThemeScheme = "light" | "dark";

export interface DayviseThemeProps {
  /** Defaults to `dark`: the product ships the jetblack scheme. */
  readonly scheme?: ThemeScheme;
  readonly children: ReactNode;
}

export function DayviseTheme({ scheme = "dark", children }: DayviseThemeProps) {
  return (
    <div
      data-dayvise-scheme={scheme}
      style={{
        minHeight: "100vh",
        background: "var(--dayvise-color-canvas)",
        color: "var(--dayvise-color-text-primary)",
        fontFamily: "var(--dayvise-font-family-sans)",
        fontSize: "var(--dayvise-font-size-md)",
        lineHeight: "var(--dayvise-line-height-normal)",
        boxSizing: "border-box",
      }}
    >
      <style href="dayvise-design-tokens" precedence="dayvise">
        {dayviseStylesheet()}
      </style>
      {children}
    </div>
  );
}
